/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../../component/button";
import { withTranslation } from "react-i18next";
import { DialogContent, DialogContentText } from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { makeStyles } from '@mui/styles';
import formatDate from "../../../../helper/dateFormatter";

const ShowNoteDialog = (props) => {
  console.log("check props data", props);
  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     }
  // });
  // const classess = useStyles();

  return (
    <Dialog
      disableScrollLock={true}
      open={props.open}
      PaperComponent={DraggableDialogPaper}
      fullWidth={true}
      maxWidth={"lg"}
      // PaperProps={{
      //     className: classess.resizablePaper
      // }}
    >
      <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
        <div style={{ display: "flex" }}>
          <span style={{ display: "inline-flex", width: "95%" }}>
            {props.t("NOTE")}
          </span>
          <Tooltip title={props.t("CLOSE")}>
            <IconButton
              onTouchStart={() => props.close()}
              onClick={() => props.close()}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <div style={{ color: "rgba(0, 0, 0, 0.87)" }}>
          <div>{props.note.text}</div>
          <div
            style={{
              fontStyle: "italic",
              fontWeight: "bold",
              paddingTop: "1rem",
            }}
          >
            {props.note.addedBy
              ? props.note.addedBy
              : props.note.author
                ? props.note.author
                : ""}
            {props.note.dateTime && (
              <>
                <br />
                {formatDate(props.note.dateTime)}
              </>
            )}
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.close();
          }}
        >
          {props.t("CLOSE")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(ShowNoteDialog);
